// extracted by mini-css-extract-plugin
export default {"keyboard":"Keyboard_keyboard__lEUaM"};